module.exports = __webpack_public_path__ + "img/vold_Portrett3.d655ca64.jpg";